(function () {
  'use strict';

  function initVariantPicker() {
    const colorOpts = document.querySelectorAll('.np-color-opt');
    const sizeOpts = document.querySelectorAll('.np-size-opt');
    const hiddenSelect = document.querySelector('.np-hidden-select');

    if (!hiddenSelect) return;

    function getSelectedValues() {
      const vals = {};
      colorOpts.forEach(el => {
        if (el.classList.contains('active')) {
          vals.color = el.dataset.value;
        }
      });
      sizeOpts.forEach(el => {
        if (el.classList.contains('active')) {
          vals.size = el.dataset.value;
        }
      });
      return vals;
    }

function updateHiddenSelect() {
  const { color, size } = getSelectedValues();
  for (const option of hiddenSelect.options) {
    const text = option.textContent.trim();
    const matchColor = !color || text.includes(color);
    const matchSize = !size || text.split(' / ').map(s => s.trim()).includes(size);
    if (matchColor && matchSize) {
      hiddenSelect.value = option.value;

      // Oppdater alle product form inputs
      document.querySelectorAll('input[name="id"]').forEach(input => {
        input.value = option.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Trigger Dawn sin URL oppdatering
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${option.value}`);

      // Trigger page refresh for å laste nytt bilde
      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        const url = `${productInfo.dataset.url}?variant=${option.value}&section_id=${productInfo.dataset.section}`;
        fetch(url)
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newMedia = doc.querySelector('media-gallery ul');
            const currentMedia = document.querySelector('media-gallery ul');
            if (newMedia && currentMedia) {
              currentMedia.innerHTML = newMedia.innerHTML;
            }
          });
      }

      break;
    }
  }
}

function updateGallery() {
  setTimeout(() => {
    const slider = document.querySelector('.product__media-list');
    const activeSlide = slider.querySelector('.slider__slide.is-active');
    if (activeSlide) {
      const index = Array.from(slider.querySelectorAll('.slider__slide')).indexOf(activeSlide);
      slider.scrollTo({ left: slider.clientWidth * index, behavior: 'smooth' });
      document.querySelectorAll('.np-dot').forEach((d, i) => {
        d.classList.toggle('active', i === index);
      });
    }
  }, 300);
}
function updateSizeAvailability(selectedColor) {
  sizeOpts.forEach(sizeOpt => {
    const availColors = sizeOpt.dataset.availColors || '';
    const isAvailable = availColors.split('|').includes(selectedColor);
    sizeOpt.classList.toggle('oos', !isAvailable);
    sizeOpt.setAttribute('tabindex', isAvailable ? '0' : '-1');
  });
}
    colorOpts.forEach(opt => {
      opt.addEventListener('click', () => {
        colorOpts.forEach(c => {
          c.classList.remove('active');
          c.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('active');
        opt.setAttribute('aria-checked', 'true');
        updateHiddenSelect();
        updateSizeAvailability(opt.dataset.value);
        setTimeout(updateGallery, 100);
      });

      opt.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          opt.click();
        }
      });
    });

    sizeOpts.forEach(opt => {
      if (opt.classList.contains('oos')) return;

      opt.addEventListener('click', () => {
        sizeOpts.forEach(s => {
          s.classList.remove('active');
          s.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('active');
        opt.setAttribute('aria-checked', 'true');
        updateHiddenSelect();
      });

      opt.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          opt.click();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPicker);
  } else {
    initVariantPicker();
  }

})();
// Dots for bildegalleri
const slides = document.querySelector('.product__media-list');
const dots = document.querySelectorAll('.np-dot');

if (slides && dots.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(slides.children).indexOf(entry.target);
        dots.forEach(d => d.classList.remove('active'));
        if (dots[index]) dots[index].classList.add('active');
      }
    });
  }, { threshold: 0.5, root: slides });

  Array.from(slides.children).forEach(slide => observer.observe(slide));
}
